enum TENANT_BILLING_ACTION_TYPES {
	GET_TENANT_BILLING_DATA = 'GET_TENANT_BILLING_DATA',
	GET_TENANT_BILLING_DATA_SUCCESS = 'GET_TENANT_BILLING_DATA_SUCCESS',

	UPDATE_TENANT_BILLING_DATA = 'UPDATE_TENANT_BILLING_DATA',
	UPDATE_TENANT_BILLING_DATA_SUCCESS = 'UPDATE_TENANT_BILLING_DATA_SUCCESS',
}

export default TENANT_BILLING_ACTION_TYPES;
